// extracted by mini-css-extract-plugin
export default {"NotificationsContainer":"bBY54Y66","ValidationText":"qtr2r8vU"};